import React from 'react';
import { useBranding } from '../../branding/BrandingContext';
import { buildSalesWhatsappLink } from '../../utils/whatsapp';

const Surpresa = () => {
  const branding = useBranding();
  const brandName = branding.name || 'Gourmex';
  const surpriseLogo = branding.logos?.mark || branding.logos?.primary;
  const youtubeId = 'KBx9ammWUfE';
  const whatsappLink = buildSalesWhatsappLink(
    'Olá! Acabei de assistir o vídeo e quero pegar meu acesso gratuito ao GCE!!'
  );

  return (
    <div className="min-h-screen bg-[#12111F] flex flex-col items-center justify-start px-4 py-8 text-white">
      {surpriseLogo ? (
        <img src={surpriseLogo} alt={`${brandName} Logo`} className="w-48 mb-8" />
      ) : (
        <div className="text-3xl font-bold mb-8">{brandName}</div>
      )}

      <div className="w-full max-w-[640px] aspect-video mb-6">
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&playsinline=1&rel=0&modestbranding=1`}
          title="Vídeo Surpresa"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
      </div>

      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-600 hover:bg-green-700 text-white text-lg font-semibold px-6 py-3 rounded-lg shadow-md transition-all duration-300"
      >
        🎁 Clique aqui e pegue seu acesso gratuito ao GCE!!
      </a>
    </div>
  );
};

export default Surpresa;
